// Lógica pura (sin React/Firebase) para administrar el mapa de monedas de
// un evento, guardado en inscripcionesConfiguracion/configuracion/moneda/.
//
// Regla del negocio (confirmada contra datos reales de eventos ya
// configurados a mano): de las monedas de un evento, exactamente una tiene
// tipo "base" — esa es la que se usa para calcular el monto que se le
// manda a la pasarela de pago. Las demás son "opcional".
//
// cambioAPeso = cuántos pesos mexicanos equivale 1 unidad de esa moneda
// (así se calculan los montos que se mandan a la pasarela).
// tipoCambio = cuántas unidades de esta moneda equivalen a 1 unidad de la
// moneda base (dato informativo que ve el atleta al elegir moneda). Para
// la moneda base, tipoCambio siempre es 1.

export function siguienteClaveMoneda(monedas) {
  const numeros = Object.keys(monedas || {})
    .map((clave) => {
      const match = /^moneda_(\d+)$/.exec(clave);
      return match ? parseInt(match[1], 10) : 0;
    })
    .filter((n) => !isNaN(n));
  const maximo = numeros.length > 0 ? Math.max(...numeros) : 0;
  return `moneda_${maximo + 1}`;
}

// Recibe el mapa completo con la moneda ya agregada/editada (con su
// cambioAPeso y tipo "base"/"opcional" ya decididos) y devuelve un mapa
// nuevo con el tipoCambio de cada moneda recalculado en relación a la base.
export function recalcularTiposDeCambio(monedas) {
  const claves = Object.keys(monedas);
  const claveBase = claves.find((clave) => monedas[clave].tipo === "base");
  const cambioAPesoBase = claveBase ? Number(monedas[claveBase].cambioAPeso) || 1 : 1;

  const resultado = {};
  claves.forEach((clave) => {
    const moneda = monedas[clave];
    const cambioAPeso = Number(moneda.cambioAPeso) || 0;
    const tipoCambio =
      clave === claveBase ? 1 : cambioAPeso > 0 ? cambioAPesoBase / cambioAPeso : 0;
    resultado[clave] = {
      ...moneda,
      cambioAPeso,
      tipoCambio: Math.round(tipoCambio * 10000) / 10000,
    };
  });
  return resultado;
}

// Aplica la moneda guardada (nueva o editada) al mapa completo: si se marcó
// como base, el resto pasa a "opcional"; luego recalcula los tipoCambio.
export function aplicarMonedaGuardada(monedas, clave, monedaGuardada) {
  const siguiente = { ...monedas, [clave]: { ...monedaGuardada } };

  if (monedaGuardada.tipo === "base") {
    Object.keys(siguiente).forEach((otraClave) => {
      if (otraClave !== clave) {
        siguiente[otraClave] = { ...siguiente[otraClave], tipo: "opcional" };
      }
    });
  }

  return recalcularTiposDeCambio(siguiente);
}

export function eliminarMoneda(monedas, clave) {
  const restantes = { ...monedas };
  delete restantes[clave];
  return recalcularTiposDeCambio(restantes);
}

export function esMonedaBase(moneda) {
  return Boolean(moneda) && moneda.tipo === "base";
}

export function puedeEliminar(monedas, clave) {
  const claves = Object.keys(monedas || {});
  if (claves.length <= 1) {
    return { permitido: false, motivo: "Debe existir al menos una moneda." };
  }
  if (esMonedaBase(monedas[clave])) {
    return {
      permitido: false,
      motivo: "No puedes eliminar la moneda base. Primero marca otra moneda como base.",
    };
  }
  return { permitido: true };
}
